import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconHomeFill: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M2 13.635L11.293 4.43625C11.6835 4.04982 12.3165 4.04982 12.707 4.43625L22 13.635H20V21.5539C20 22.1006 19.5523 22.5438 19 22.5438H14V15.6148H10V22.5438H5C4.44772 22.5438 4 22.1006 4 21.5539V13.635H2Z"
      fill="currentColor"
    />
  </Svg>
)
